module.exports = __webpack_public_path__ + "img/headerImage.f421aac1.png";